import DashboardLayout from '@/components/DashboardLayout';
import DashboardGrid from '@/components/DashboardGrid';
import Footer from '@/components/Footer';
import AchievementsBanner from '@/components/AchievementsBanner';
import WelcomePopup from '@/components/WelcomePopup';
import PartnersMarquee from '@/components/PartnersMarquee';
import NewsSection from '@/components/NewsSection';

const Index = () => {
  return (
    <DashboardLayout>
      <DashboardGrid />
      <AchievementsBanner />
      <NewsSection />
      <PartnersMarquee />
      <Footer />
      <WelcomePopup />
    </DashboardLayout>
  );
};

export default Index;
